<template>
  <div :class="['banner', extensionType === '/semnav' || extensionType === '/chunsheng' ? 'newH' : '']">
    <video
      v-if="extensionType === '/sempc' || extensionType === '/semnav' || extensionType === '/landing/semqa'"
      src="@/assets/video/banner.mp4"
      id="video1"
      style="width: 100%;margin-top: -90px;"
      muted
      autoplay
      loop
    />
    <img v-if="extensionType === '/chunsheng'" src="@/assets/images/chunsheng.jpg" class="bannerimg" />
    <div :class="['text', $route.path === '/chunsheng' ? 'nomask' : '']">
      <Form
        v-if="showForm"
        @msg="msg => $emit('msg', msg)"
        @setShowSuccessDialog="setShowSuccessDialog"
        :landingPageName="landingPageName"
      />
      <div class="banner_tabbox">
        <div class="tab_listbox">
          <div class="list font">
            <img class="font1" src="@/assets/images/font1.png" />
          </div>
          <div class="list_block font">
            <img class="font2" src="@/assets/images/font2.png" />
          </div>
          <div class="list column font">
            <img class="font3" src="@/assets/images/font3.png" />
          </div>
          <div class="list_block column font">
            <img class="font4" src="@/assets/images/font4.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showForm: Boolean,
    video: String,
    landingPageName: {
      type: String,
      default: '',
    },
  },
  computed: {
    extensionType() {
      return this.$route.path
    },
  },
  components: {
    Form: () => import('./Form.vue'),
  },
  methods: {
    closeform(e) {
      console.log(e)
    },
    setShowSuccessDialog(v) {
      this.$emit('setShowSuccessDialog', v)
    },
  },
}
</script>

<style lang="less" scoped>
.bannerimg {
  min-width: 1200px;
  width: 100%;
  height: 616px;
}
.banner {
  height: 690px;
  position: relative;
  margin-top: -90px;
  overflow: hidden;
  width: 100%;
  .font1 {
    width: 243px;
    height: 19px;
  }
  .font2 {
    width: 212px;
    height: 19px;
  }
  .font3 {
    width: 150px;
    height: 55px;
  }
  .font4 {
    width: 185px;
    height: 52px;
  }
  video {
    object-fit: fill;
    min-height: 670px;
    z-index: -11;
    display: inline-block;
    vertical-align: baseline;
    width: 100%;
  }

  source {
    min-width: 100%;
    min-height: 670px;
    height: auto;
    width: auto;
  }

  .text {
    width: 100%;
    height: 500px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 56px;
    top: 90px;
    z-index: 999;
    position: absolute;
    display: flex;
    justify-content: center;
    // margin-top: 20px;
  }
  .nomask {
    background: none;
    /deep/ .txt_box {
      justify-content: flex-end;
    }
  }
  .banner_tabbox {
    width: 100%;
    height: 100px;
    background: rgba(0, 0, 0, 0.8);
    position: absolute;
    bottom: -100px;
    color: #fff;
    text-align: center;
    margin: auto;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
  }
  .tab_listbox {
    height: 100px;
    display: flex;

    .list {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 350px;
      background: #333333;
      opacity: 0.67;
      font-size: 20px;
      color: #fff;
      height: 100px;
      line-height: 25px;
    }

    .list-plus {
      font-size: 16px;
      font-family: PingFangSC;
      font-weight: 500;
      color: #fff;
      line-height: 22px;
      position: relative;
      top: -10px;
      color: rgba(237, 201, 160, 1);
    }

    .list_block {
      width: 350px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #fff;
      background: #000000;
      opacity: 0.8;
    }
    .font {
      // position: relative;
      // background-image: -webkit-linear-gradient(180deg, #FFEECF 0%, #EDC9A0 100%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
      color: rgba(237, 201, 160, 1);
      font-weight: 700;
    }
    .column {
      flex-direction: column;
    }
    .mb_8 {
      margin-bottom: 4px;
    }
    .block {
      height: 100px;
    }
  }
}
/deep/ .txt_box .title {
  width: 762px !important;
  height: 236px !important;
}
.newH {
  height: 716px;
  .text {
    height: 526px;
  }
  /deep/ .toTry {
    margin-top: 93px !important;
  }
  .banner_tabbox {
    // bottom: -126px !important;
  }
  /deep/ .txt_box .title {
    width: 762px !important;
    height: 160px !important;
  }
}
</style>
